<style scoped>
/* @import "../../styles/common/common.less"; */
/* @import "../../styles/common/List.less";  */

.el-tag {
  height: 20px !important;
  padding: 0 5px !important;
  line-height: 19px !important;
}

.ivu-icon-arrow-shrink,
.ivu-icon-arrow-expand,
.ivu-icon-android-close {
  font-size: 20px;
  color: #999;
  transition: color 0.2s ease;
  position: relative;
  top: 0px;
  margin-left: 10px;
}

.ivu-icon-arrow-shrink:hover {
  color: #444;
}

.ivu-icon-arrow-expand:hover {
  color: #444;
}

.ivu-icon-android-close:hover {
  color: #444;
}
.search-plus-collapse {
  margin-bottom: 12px;
  justify-content: space-around;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">分润结算</div>
      <ZD-list-querys>
        <template slot="inputs">
          <div class="list-query-child-div flex">
            <div class="query-title-div">类型</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                v-model="queryParam.type"
                size="small"
                clearable
              >
                <el-option label="分润" value="01"></el-option>
                <el-option label="结算" value="02"></el-option>
              </el-select>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算周期</div>
            <div class="query-inputs-div flex-1">
              <el-date-picker
                clearable
                v-model="seTime"
                :picker-options="pickerOptions"
                style="width:290px;"
                type="monthrange"
                size="small"
                value-format="yyyy-MM"
                range-separator="-"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="handleseChange"
              ></el-date-picker>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">金额</div>
            <div class="query-inputs-div flex-1">
              <el-input
                size="small"
                v-model="queryParam.money"
                placeholder="请输入内容"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">说明</div>
            <div class="query-inputs-div flex-1">
              <el-input
                type="textarea"
                size="small"
                v-model="queryParam.remark"
                placeholder="请填写金额计算方式"
                clearable
              ></el-input>
            </div>
          </div>
          <div class="list-query-child-div flex">
            <div class="query-title-div">结算依据</div>
            <div class="query-inputs-div flex-1">
              <el-select
                class="full-width"
                v-model="queryParam.settleBasis"
                size="small"
                clearable
              >
                <el-option label="自有电表" value="01"></el-option>
                <el-option label="对方电表" value="02"></el-option>
                <el-option label="系统平台" value="03"></el-option>
              </el-select>
            </div>
          </div>
        </template>

        <template slot="actions">
          <button class="common-bg-button" @click="getAdd">
            提交
          </button>
          <button class="common-empty-button" @click="reset()">重 置</button>
        </template>
      </ZD-list-querys>
      <div class="query-inputs-div" style="margin-bottom:20px;">
        <span>分润结算记录列表</span>
        <span style="margin: 0 10px;">时间范围</span>
        <el-date-picker
          clearable
          v-model="searchTime"
          :picker-options="pickerOptions"
          style="width:290px;"
          type="monthrange"
          size="small"
          value-format="yyyy-MM"
          range-separator="-"
          start-placeholder="开始月份"
          end-placeholder="结束月份"
          @change="handleDateChange"
        ></el-date-picker>

        <span style="margin-left:20px;"
          ><el-button type="primary" @click="initList(pagination, true)"
            >查找</el-button
          >
          <el-button type="primary" @click="handleCommand"
            >导出</el-button
          ></span
        >
      </div>
      <div class="wlplat-el-tb">
        <!--表格区-->
        <el-table :data="listData" :stripe="true" class="list_tb" border>
          <el-table-column
            prop="yearMon"
            label="结算周期"
            min-width="140"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.isshow">{{
                scope.row.startYearMon + " - " + scope.row.endYearMon
              }}</span>
              <el-date-picker
                v-else
                clearable
                v-model="scope.row.editTime"
                :picker-options="pickerOptions"
                style="width:290px;"
                type="monthrange"
                size="small"
                value-format="yyyy-MM"
                range-separator="-"
                start-placeholder="开始月份"
                end-placeholder="结束月份"
                @change="handleeditChange"
              ></el-date-picker>
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            label="类型"
            min-width="110"
            align="center"
          >
            <div slot-scope="scope">
              <span v-if="!scope.row.isshow">{{
                scope.row.type == "01" ? "分润" : "结算"
              }}</span>
              <el-select
                v-else
                class="full-width"
                v-model="scope.row.type"
                size="small"
                clearable
              >
                <el-option label="分润" value="01"></el-option>
                <el-option label="结算" value="02"></el-option>
              </el-select>
            </div>
          </el-table-column>
          <el-table-column
            prop="money"
            label="金额（元）"
            min-width="170"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.isshow">{{ scope.row.money }}</span>
              <el-input
                v-else
                v-model="scope.row.money"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="settleBasis"
            label="结算依据"
            min-width="110"
            align="center"
          >
            <div slot-scope="scope">
              <span v-if="!scope.row.isshow">{{
                scope.row.settleBasis == "01"
                  ? "自有电表"
                  : scope.row.settleBasis == "02"
                  ? "对方电表"
                  : "系统平台"
              }}</span>
              <el-select
                v-else
                class="full-width"
                v-model="scope.row.settleBasis"
                size="small"
                clearable
              >
                <el-option label="自有电表" value="01"></el-option>
                <el-option label="对方电表" value="02"></el-option>
                <el-option label="系统平台" value="03"></el-option>
              </el-select>
            </div>
          </el-table-column>

          <el-table-column
            prop="remark"
            label="说明"
            min-width="170"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.isshow">{{ scope.row.remark }}</span>
              <el-input
                v-else
                v-model="scope.row.remark"
                placeholder="请输入"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            label="录入时间"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="录入人"
            min-width="170"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdWhen"
            sortable
            label="操作"
            min-width="160"
          >
            <template slot-scope="scope">
              <el-button @click="edit(scope.row)">
                {{ scope.row.isshow ? "提交" : "编辑" }}
              </el-button>

              <!-- <el-button @click="del(scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!--分页区-->
        <div class="list-pagination">
          <ZD-pagination
            :pagination="pagination"
            v-on:pageUpdate="initList"
          ></ZD-pagination>
        </div>
        <Spin fix v-if="showFix">
          <Icon type="load-c" size="32" class="demo-spin-icon-load"></Icon>
          <div>加载中...</div>
        </Spin>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
// 消息配置文件
import msgCfg from "@/config/msg.js";
// 系统配置文件
import config from "@/config/configLog.js";
import util from "@/common/util.js";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      editForm: {},
      stationName: "",
      stationNo: "",
      isMessageTypeName: true,
      pagination: pageConfig.pagination,
      seTime: [],
      editTime: [],
      searchTime: [], //选择时间
      pickerOptions: {
        //修改el-date-picker的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      filePath: "", //导出路径
      pageConfig: pageConfig, // 页面配置
      firstMessageType: "",
      firstMessageTypeArr: [],
      selStartDate: msgCfg.startDate,
      selEndDate: msgCfg.endDate,
      proStartDate: "",
      startDate: "",
      endDate: "",
      searchDate: "",
      proEndDate: "",
      sysConfig: config,
      select: msgCfg.select,
      name: config.pileRecordHistory.List.name,
      routeName: config.cust.List.name_en,
      searchVal: "",
      searchTxt: "请输入桩编号",
      selections: [],
      // corps:[],
      custPhone: "",
      pageParams: {
        total: 0,
        opts: config.page.opts,
        currentPage: 1,
        pageSize: config.page.pageSize,
        pageLayout: config.page.layout,
      },
      queryParam: {
        pageNum: 0,
        pageSize: config.page.pageSize,
      },
      listData: [],
      showFix: false,
      initModal: true,
      showPopover: false,
    };
  },
  methods: {
    // 编辑日期改变
    handleeditChange(val) {
      if (val) {
        this.editForm.startYearMon = val[0];
        this.editForm.endYearMon = val[1];
      } else {
        delete this.editForm.startYearMon;
        delete this.editForm.endYearMon;
      }
    },
    // 添加日期改变
    handleseChange(val) {
      if (val) {
        this.seTime = [val[0], val[1]];
        // this.queryParam.endYearMon = val[1];
      } else {
        delete this.seTime;
        // delete this.queryParam.endYearMon;
      }
    },
    //选择结束时间
    handleDateChange(val) {
      console.log(val);
      if (val) {
        this.queryParam.startYearMon = val[0];
        this.queryParam.endYearMon = val[1];
      } else {
        delete this.queryParam.startYearMon;
        delete this.queryParam.endYearMon;
      }
    },
    // init() {
    //   this.getListData(this.pagination, true);
    // },
    checkDate(e) {
      this.proStartDate = e + " 00:00:00";
      this.proEndDate = e + " 23:59:59";
      this.queryParam.fromTime = this.proStartDate;
      this.queryParam.toTime = this.proEndDate;
    },
    // 选择起始时间
    updateProStartDate(e) {
      this.proStartDate = e;
    },
    //选择结束时间
    updateProEndDate(e) {
      this.proEndDate = e;
    },

    setCorpNoQueryList() {
      this.corpNo = Cookies.get("currCorpNo");
    },

    init() {
      this.stationNo = this.$route.query.stationNo;
      this.stationName = this.$route.query.stationName;
      console.log(this.stationName);
      this.initList(this.pagination, true);
    },
    initList(pagination, reload = false) {
      var _this = this;
      _this.$U.showLoading(_this);
      _this.queryParam.pageNum = pagination.current - 1;
      if (reload) {
        _this.pagination.current = 1;
        _this.queryParam.pageNum = 0;
      }
      _this.queryParam.pageSize = pagination.pageSize;

      var listUrl = config.baseUrl + _this.$A.profitSettleRecord.page;
      // console.log(listUrl);
      _this.queryParam.stationNo = _this.stationNo;
      _this.queryParam.stationName = _this.stationName;
      _this.$H
        .post(_this, listUrl, JSON.stringify(_this.queryParam))
        .then((res) => {
          // console.log(res);
          res.data.data.content.forEach((item) => {
            item.isshow = false;
          });
          _this.listData = res.data.data.content;
          // console.log(_this.listData);
          _this.pagination.total = res.data.data.totalElements;
          _this.$U.hideLoading(_this);
        });
    },
    getList() {
      var _this = this;
      _this.$U.showLoading(_this);

      var listUrl = config.baseUrl + _this.$A.profitSettleRecord.list;
      // console.log(listUrl);
      _this.queryParam.stationNo = _this.stationNo;
      _this.queryParam.stationName = _this.stationName;
      _this.$H
        .post(_this, listUrl, JSON.stringify(_this.queryParam))
        .then((res) => {
          //  console.log(response);
          res.data.data.content.forEach((item) => {
            item.isshow = false;
          });
          _this.listData = res.data.data.content;
          // console.log(_this.listData);
          _this.pageParams.total = res.data.data.totalElements;
          _this.$U.hideLoading(_this);
        });
    },
    initQureyParam(type) {
      // 初始化查询参数
      this.queryParam.sortEntityList = [];
      this.queryParam.sortEntityList.push(
        util.sortList(config.list.sortKey, config.list.sortValue)
      );

      this.queryParam.pageNum = this.pageParams.currentPage - 1;
      this.queryParam.pageSize = this.pageParams.pageSize;
      this.queryParam.fromTime = this.proStartDate;
      this.queryParam.toTime = this.proEndDate;
      this.queryParam.rcsCode = this.searchVal;
      this.queryParam.firstMessageType = this.firstMessageType;
      if (util.notNull(type) && "search" === type) {
        this.pageParams.currentPage = 1;
      }
    },

    downloadFile(url, name) {
      var a = document.createElement("a");
      a.setAttribute("href", url);
      a.setAttribute("download", name);
      a.setAttribute("target", "_blank");
      let clickEvent = document.createEvent("MouseEvents");
      clickEvent.initEvent("click", true, true);
      a.dispatchEvent(clickEvent);
    },
    handleCommand() {
      let _this = this;
      var listUrl = config.baseUrl + _this.$A.profitSettleRecord.export;

      _this.$U.showLoading(_this);
      _this.$H
        .post(_this, listUrl, JSON.stringify(_this.queryParam))
        .then((res) => {
          //  console.log(res);
          let filePath = res.data.data.filePath.slice(4);
          // console.log(filePath);
          var downUrl = "http://ocharge.shzhida.com:6777" + filePath;
          // console.log(downUrl);
          window.open(downUrl, "_blank");

          _this.$U.hideLoading(_this);
        });
    },

    getAdd() {
      let _this = this;
      if (_this.queryParam.type == null || _this.queryParam.type == "") {
        return _this.$message.error("请选择类型!");
      }
      if (_this.queryParam.money == "" || _this.queryParam.money == null) {
        return _this.$message.error("请输入金额!");
      }
      if (
        _this.queryParam.settleBasis == "" ||
        _this.queryParam.settleBasis == null
      ) {
        return _this.$message.error("请选择结算依据!");
      }
      if (_this.queryParam.remark == "" || _this.queryParam.remark == null) {
        return _this.$message.error("请填写说明!");
      } else if (_this.seTime == null || _this.seTime.length == 0) {
        return _this.$message.error("请选择时间区间!");
      } else {
        let obj = {
          stationNo: _this.stationNo,
          startYearMon:_this.seTime[0],
          type:_this.queryParam.type,
          endYearMon:_this.seTime[1],
        }
        _this.$H
          .get(_this, _this.$A.pilestation.checkProfit, obj)
          .then((res) => {
            if (res.data.data) {
              _this
                .$confirm("已有该数据此操作将确认覆盖, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(() => {
                  _this.$U.showLoading(_this);
                  var listUrl =
                    config.baseUrl + _this.$A.profitSettleRecord.add;
                  _this.queryParam.stationNo = _this.stationNo;
                  _this.queryParam.stationName = _this.stationName;
                  _this.queryParam.startYearMon = _this.seTime[0];
                  _this.queryParam.endYearMon = _this.seTime[1];
                  _this.$H
                    .post(_this, listUrl, JSON.stringify(_this.queryParam))
                    .then((res) => {
                      delete _this.queryParam.type;
                      _this.seTime = [];
                      delete _this.queryParam.money;
                      delete _this.queryParam.remark;
                      delete _this.queryParam.settleBasis;
                      _this.searchTime = [];
                      delete _this.queryParam.startYearMon;
                      delete _this.queryParam.endYearMon;
                      _this.initList(_this.pagination, true);
                      _this.$U.hideLoading(_this);
                      _this.$message.success("添加成功!");
                    });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消",
                  });
                });
            } else {
              _this.$U.showLoading(_this);
              var listUrl = config.baseUrl + _this.$A.profitSettleRecord.add;
              _this.queryParam.stationNo = _this.stationNo;
              _this.queryParam.stationName = _this.stationName;
              _this.queryParam.startYearMon = _this.seTime[0];
              _this.queryParam.endYearMon = _this.seTime[1];
              _this.$H
                .post(_this, listUrl, JSON.stringify(_this.queryParam))
                .then((res) => {
                  delete _this.queryParam.type;
                  _this.seTime = [];
                  delete _this.queryParam.money;
                  delete _this.queryParam.remark;
                  delete _this.queryParam.settleBasis;
                  _this.searchTime = [];
                  delete _this.queryParam.startYearMon;
                  delete _this.queryParam.endYearMon;
                  _this.initList(_this.pagination, true);
                  _this.$U.hideLoading(_this);
                  _this.$message.success("添加成功!");
                });
            }
          });
      }
    },

    edit(row) {
      // console.log(1);
      let _this = this;
      row.isshow = !row.isshow;
      _this.$set(row, "editTime", [row.startYearMon, row.endYearMon]);
      // _this.editForm = JSON.parse(JSON.stringify(row))
      // console.log(_this.editForm)
      if (row.isshow === false) {
        console.log(row);
        if (row.type == null || row.type == "") {
          row.isshow = true;
          return _this.$message.error("请选择类型!");
        }
        if (row.editTime == null || row.editTime.length == 0) {
          row.isshow = true;
          return _this.$message.error("请选择时间区间!");
        }
        if (row.settleBasis == "" || row.settleBasis == null) {
          row.isshow = true;
          return _this.$message.error("请选择结算依据!");
        }
        if (row.money == "" || row.money == null) {
          row.isshow = true;
          return _this.$message.error("请输入金额!");
        } else if (row.remark == "" || row.remark == null) {
          row.isshow = true;
          return _this.$message.error("请填写说明!");
        } else {
          _this.$U.showLoading(_this);
          var listUrl = config.baseUrl + _this.$A.profitSettleRecord.edit;
          delete row.editTime;
          if (
            _this.editForm.startYearMon == "" ||
            _this.editForm.startYearMon == null
          ) {
            row.startYearMon = row.startYearMon;
            row.endYearMon = row.endYearMon;
          } else {
            row.startYearMon = _this.editForm.startYearMon;
            row.endYearMon = _this.editForm.endYearMon;
          }
          console.log(row);

          _this.$H.post(_this, listUrl, JSON.stringify(row)).then((res) => {
            //  console.log(res);
            _this.initList(_this.pagination, true);
            _this.$U.hideLoading(_this);
            _this.$message.success("编辑成功");
          });
        }
      }
    },
    del(row) {
      let _this = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var listUrl =
            config.baseUrl +
            _this.$A.profitSettleRecord.del +
            "/" +
            row.recordId;
          _this.$H.get(_this, listUrl).then((res) => {
            _this.initList(_this.pagination, true);
            _this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    reset() {
      delete this.queryParam.type;
      delete this.seTime;
      delete this.queryParam.money;
      delete this.queryParam.remark;
      delete this.queryParam.settleBasis;
      this.initList(this.pagination, true);
    },
  },
  mounted() {
    this.init();
    // this.initList();
    const that = this;
    window.addEventListener("resize", function() {
      if (!that.initModal) {
        var tempHeight = document.body.clientHeight - 60;
        that.moHeight = {
          height: tempHeight + "px",
        };
      }
    });
  },
  watch: {
    showFix() {
      if (this.showFix) {
        this.showPopover = false;
      }
    },
  },
};
</script>
